import { createSlice } from "@reduxjs/toolkit";

const providerSlice = createSlice({
  name: "provider",
  initialState: {
    provider: null,
    loading: false,
    allReviews: [],
    ListProvider: [],
  },
  reducers: {
    setProvider: (state, action) => {
      state.provider = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setProviderReviews: (state, action) => {
      state.allReviews = action.payload; // Action to set reviews
    },
    setListProvider: (state, action) => {
      state.ListProvider = action.payload;
    },
  },
});

export const { setProvider, setLoading, setProviderReviews, setListProvider } =
  providerSlice.actions;
export default providerSlice.reducer;
